import { useWindowWidth } from 'hooks/windowWidth';
import { Container } from './styles';

export const OptionalStepMobileWarning: React.FC = () => {
  const { isMobileScreen } = useWindowWidth();

  if (!isMobileScreen) return null;
  return <Container>Opcional</Container>;
};
